import React, { Component } from 'react';
import { Waypoint } from "react-waypoint";
import * as d3 from 'd3';
import './App.css';

import IconSkinTone from './images/skintone.png';
import IconAmiibo from './images/amiibo.png';
import IconTraits from './images/traits.png';

import GameImgHappy from './images/game-happy2.jpeg';

//import components
import Modal from "./components/Modal";
import Button from './components/Button';
import TipBubble from './components/TipBubble';

//import sections
import Header from './sections/Header';
import Footer from './sections/Footer';
import VillagerStep from './sections/VillagerStep';
import VillagerTable from './components/VillagerTable';
import TopVillagersChart from './sections/TopVillagersChart';
//import FullVillagersList from './sections/FullVillagersList';
import VoteSummary from './sections/VoteSummary';
import VoteEnd from './sections/VoteEnd';


import VillageColors from './data/villager_colors';
import VillagerData from './data/anch_villagers';


const villagerSkinColorMap = new Map(VillageColors.villagercolors.map(villager => [
  villager.id, `#${villager.skin_color}`
]));

const villagerTextColorMap = new Map(VillageColors.villagercolors.map(villager => [
  villager.id, `#${villager.text_color}`
]));

function flatten(arr) {
     return [].concat(...arr);
 }

const allVillagers = flatten(VillagerData.villagersdata);
const villagerTotal = allVillagers.length;

allVillagers.forEach((villager) => {
  //let base = 30;
  let base = Math.round(villagerTotal/10)
  if(villager.Average_Popularity_Ranking<=base){
    villager.tier = 1
  }else if( villager.Average_Popularity_Ranking > base && villager.Average_Popularity_Ranking<=base*2){
    villager.tier = 2
  }else if( villager.Average_Popularity_Ranking > base*2 && villager.Average_Popularity_Ranking<=base*3){
    villager.tier = 3
  }else if( villager.Average_Popularity_Ranking > base*3 && villager.Average_Popularity_Ranking<=base*4){
    villager.tier = 4
  }else if( villager.Average_Popularity_Ranking > base*4 && villager.Average_Popularity_Ranking<=base*5){
    villager.tier = 5
  }else if( villager.Average_Popularity_Ranking > base*5 && villager.Average_Popularity_Ranking<=base*6){
    villager.tier = 6
  }else if( villager.Average_Popularity_Ranking > base*6 && villager.Average_Popularity_Ranking<=base*7){
    villager.tier = 7
  }else if( villager.Average_Popularity_Ranking > base*7 && villager.Average_Popularity_Ranking<=base*8){
    villager.tier = 8
  }else if( villager.Average_Popularity_Ranking > base*8 && villager.Average_Popularity_Ranking<=base*9){
    villager.tier = 9
  }else{
    villager.tier = 10
  }

});

const VillagerStepRef = React.forwardRef((props, ref) => {
  return <VillagerStep innerRef={ref} {...props} />
})

const steps = ["summary","appearance-unique", "appearance-goodlooking", "appearance-skincolor", "appearance-skinbrightness", "traits-personality", "traits-species", "traits-house", "traits-hobby", "traits-star-sign", "gameplay-amiibo","gameplay-debutgame","gameplay-rarity"];
var stepsArray = steps.map(step => (
  {'id':step}
))

class App extends Component {
  constructor(props){
      super(props);
      this.state = {
        currentStep: "",
        lastPosition: 0,
        currentSection:"",
        isModalVisible:false,
        vizWidth: 0,
        vizHeight: 0
      }
      this.handleSvgSize = this.handleSvgSize.bind(this);
   }

  componentDidMount() {
    window.addEventListener('resize', this.onResize, false)
    this.onResize()
  }

  onResize = () => {

    let bodyRect = document.body.getBoundingClientRect();
    //let numberSectionRect = document.getElementById('flavor-number').getBoundingClientRect();

    stepsArray.forEach((step) => {
     var stepRect = document.getElementById(`villager-${step.id}`).getBoundingClientRect();
     var top = Math.max(0, stepRect.top - bodyRect.top);
     var bottom = top + stepRect.height;

     Object.assign(step, {top, bottom, height: stepRect.height});
    });

    let vizHeight = Math.min(1.5 * window.innerHeight, 1.5 * d3.max(stepsArray, step => step.height));

    //let vizWidth = document.getElementById('section-villagers').getBoundingClientRect().width;
    let vizWidth = document.getElementById('force-chart').getBoundingClientRect().width;

    this.handleSvgSize(vizWidth, vizHeight)
  }

    onStepEnter = (step, {currentPosition, previousPosition}) => {
      //this.setState({step})

      let sectiontitle ='';

      if (step.includes("appearance")){
        sectiontitle = "appearance"
      }else if (step.includes("traits")){
        sectiontitle = "traits"
      }else if (step.includes("gameplay")){
        sectiontitle = "gameplay"
      }

      this.setState({
          currentStep: step,
          currentSection: sectiontitle
      });

      const el = document.querySelector(`#villager-${step}`)
      el.classList.add("active");
    }

    onStepExit = (step, {currentPosition, previousPosition}) => {
      if( step === "appearance-unique"&&currentPosition === "below" || step === "gameplay-rarity"&&currentPosition === "above") {
        this.setState({currentStep: ""})
      }

      const el = document.querySelector(`#villager-${step}`)
      el.classList.remove("active");
    }


  componentDidUpdate(prevProps, prevStates) {

    if (this.state.isModalVisible !==  prevStates.isModalVisible) {
      if(this.state.isModalVisible === true){
        // When the modal is shown, we want a fixed body
        const scrollY = window.pageYOffset;
        const body = document.body;
        body.style.position = 'fixed';
        //body.style.top = scrollY*-1;
        this.setState({ lastPosition: scrollY*-1})
      }else{
        // When the modal is hidden...
        const body = document.body;
        const scrollY = this.state.lastPosition;
        body.style.position = '';
        //body.style.top = '';
        window.scrollTo(0, parseInt(scrollY || '0') * -1);
      }
    }

  }

  handleSvgSize = (width, height) => {
    this.setState({ vizWidth: width, vizHeight: height})
  }


  render() {
    const { currentStep, isModalVisible, vizWidth, vizHeight,currentSection} = this.state;

    const mobileBreakpoint = 768;
    let isPhone = (window.innerWidth <= mobileBreakpoint)?true:false;

    return (
      <div className="App">
        <Header/>
        <div className="section-wrapper">
          <div className="section-container bg-leaf">
            <section id="section-context" className="container section">
              <TipBubble>Continue reading in the latest Chrome desktop browser for the optimal viewing experience.</TipBubble>
              <p className="paragraph space-top">For many of us, the release of <a className="inline-tooltip" href="#" aria-label="A social simulation game from Nintendo for its Switch console.">Animal Crossing: New Horizons</a> in March 2020 provided a welcome escape from the early months of COVID-19. You could spend your days in lockdown on a tropical island, gardening, fishing, and even collecting art!
              </p>
              <p className="paragraph">
              However, as relaxing as the game is, there is one stressful dilemma: <span className="medium">Which animal villagers do we want to invite to our islands?</span></p>
              <p className="paragraph">You can only have 10 villagers living on your island. When villagers move out, new villagers can be invited in, and players take villager recruitment very seriously. Some villagers, like Marshal and Raymond, are so coveted that people would even spend real money to invite them to their islands!</p>
              <p className="paragraph">
              Because collecting villagers is such a big part of the game, this led us to wonder… <span className="medium">what makes an Animal Crossing villager popular?</span>
              </p>
              <VoteSummary villagers={allVillagers} villagerSkinColors={villagerSkinColorMap} villagerTextColors={villagerTextColorMap}/>

              <Button classList="btn-block" btnType="button" btnClick={() => this.setState({ isModalVisible: true })}>View all villagers</Button>
              {isModalVisible && (
                <Modal onModalClose={() => this.setState({ isModalVisible: false })}>
                  <Modal.Header>All villagers</Modal.Header>
                  <Modal.Body>
                    <p className='paragraph'>
                    As of last day of data collected (April 2021), there are 397 villagers total. You may see tied rankings, some of the tiers may have slightly more than 40 villagers, and the last tier has 34 villagers.
                    </p>
                    {/*<h3 className='table-title'>All villagers</h3>
                      */}
                    <VillagerTable villagers={allVillagers} startRange={1} endRange={40} selectedRange={`1-40`} id="summary-table" hasControl='true'/>
                  </Modal.Body>
                </Modal>
              )}

            </section>
            <section className="container section section-divider">
              <h2 className="title">What could be related to villager popularity?</h2>
              <p className="paragraph ">Once we decided how to measure villager popularity, we could begin our analysis. We compiled a set of villager attributes, created hypotheses about which attributes would contribute to popularity, and looked for patterns to prove or disprove our hypotheses. Our villager attributes fell into three categories:</p>
              <div className="category-list-container space-top-sm">
                <div className="category-list">
                  <span className="category-icon"><img alt='skintone' src={IconSkinTone}/></span>
                  <p className="category-list-title">Appearance</p>
                  <p className="category-list-description">
                    Related to how a villager looks: skin color, appearance, unique character designs
                  </p>
                </div>
                <div className="category-list">
                    <span className="category-icon"><img alt='traits' src={IconTraits}/></span>
                    <p className="category-list-title">Traits</p>
                    <p className="category-list-description">Describe a villager’s identity & personality: species, personality, hobby, star sign, house decor
                    </p>
                </div>
                <div className="category-list">
                    <span className="category-icon"><img alt='gameplay' src={IconAmiibo}/></span>
                    <p className="category-list-title">Game Play</p>
                    <p className="category-list-description">Related to how the Animal Crossing games are designed: villager rarity, Amiibo availability, debut game
                    </p>
                </div>
              </div>
            </section>
          </div>
          <div className="section-container bg-triangle">
            <section id="section-villagers" className="scroll-wrapper section">
              <div className="chart-wrapper" style={{height:(isPhone)?'auto':'100vh'}}>
                <TopVillagersChart isPhone={isPhone} chartHeight={vizHeight} chartWidth={vizWidth} currentStep={this.state.currentStep} villagers={allVillagers} villagerSkinColors={villagerSkinColorMap} villagerTextColors={villagerTextColorMap}/>
              </div>
              <div className="step-wrapper">
                {/*<div className={`heading-section bg-triangle ${this.state.currentSection?'':'non-active'}`}>
                  <h1 className={`heading ${this.state.currentSection?'active':''}`}>{this.state.currentSection}</h1>
                </div>*/}
                {steps.map(step => {
                    return (
                      <Waypoint onEnter={((obj) => this.onStepEnter(step, obj))} onLeave={((obj) => this.onStepExit(step, obj))} scrollableAncestor={window} topOffset={"33%"} bottomOffset={"66%"} key={step}>
                        <VillagerStepRef key={step} step={step} villagers={allVillagers} villagerSkinColors={villagerSkinColorMap} villagerTextColors={villagerTextColorMap} />
                      </Waypoint>
                    )
                })}
              </div>
            </section>
          </div>
          <div className="section-container bg-leaf">
            <section className="container section section-divider">
              <h2 className="title">What does this all mean?</h2>
              <p className="paragraph">Having explored so many different villager attributes, do we have an answer to the question: <span className="medium">What makes a villager popular?</span></p>

              <p className="paragraph">Through our analysis, we have found many attributes that can contribute to a villager’s popularity. The strongest trends we identified were related to:</p>

              <div className="category-list-container ">
                <div className="category-list">
                  <span className="category-icon"><img alt='skintone' src={IconSkinTone}/></span>
                  <p className="category-list-title">Appearance</p>
                  <ul className="category-list-description">
                    <li><span className="medium">Unique designs</span></li>
                    <li><span className="medium">Villager looks</span></li>
                  </ul>
                </div>
                <div className="category-list">
                    <span className="category-icon"><img alt='traits' src={IconTraits}/></span>
                    <p className="category-list-title">Traits</p>
                    <ul className="category-list-description">
                      <li><span className="medium">Personality types</span></li>
                      <li><span className="medium">Species</span></li>
                      <li><span className="medium">Hobbies</span></li>
                    </ul>
                </div>
                <div className="category-list">
                    <span className="category-icon"><img alt='gameplay' src={IconAmiibo}/></span>
                    <p className="category-list-title">Game Play</p>
                    <ul className="category-list-description">
                      <li><span className="medium">Amiibo availability</span></li>
                      <li><span className="medium">Villager rarity</span> <br/>(in relation to species)</li>
                    </ul>
                </div>
              </div>
              <p className="paragraph space-top-sm">We believe that some combination of these attributes can explain why a villager is popular or unpopular.</p>
            </section>
            <section id="section-ending" className="container section">
              <VoteEnd chartWidth={vizWidth} villagers={allVillagers}/>
            </section>
            <section className="container section section-divider">
              <h2 className="title">Final thoughts</h2>
              <p className="paragraph">To conclude our research, we believe the villagers who are popular in Animal Crossing: New Horizons have one or more of the following qualities:</p>
              <TipBubble guide="isabelle">
                <ul className="paragraph chart-key-list quality-list">
                  <li>A good looking or unique appearance</li>
                  <li>Lower probability of in-game encounter</li>
                  <li>A species that is considered “cute” or “lovable” or can be kept as a pet</li>
                  <li>A more “friendly” or “approachable” personality</li>
                </ul>
              </TipBubble>

              <p className="paragraph space-top-sm space-bottom">So the next time you play Animal Crossing, think about your favorite villagers and see if they match our definition of a popular villager!
              </p>

            </section>
          </div>
        </div>
        <div className="section-container">
          <section  id="section-credit" className="container section">
            <h2 className="title">Creators' notes</h2>
            <p className="paragraph">It's been a wonderful journey analyzing all the characterics of villagers and learning what makes a villager popular. </p>
            <p className="paragraph">A huge shout out to the community-driven encyclopedia about the game series <a className="link" href="https://api.nookipedia.com/" target="_blank">Nookipedia</a> for sharing all the villager data and assets. Thanks again to <a className="link" href="https://animalcrossingportal.com/" target="_blank">Animal Crossing Portal</a> and <a className="link" href="https://Nookazon.com" target="_blank">Nookazon</a> for collecting the popularity data that was such an important part of our study. </p>
            <p className="paragraph">And of course, thank you <a className="link" target="_blank" href="https://nookipedia.com/wiki/Animal_Crossing:_New_Horizons/Staff/">Animal Crossing creator and staff</a> for making such an amazing game. Being able to play together with friends, family, and co-workers helped with social isolation while everyone was staying at home. As you can probably tell by now, we paid tribute to Animal crossing by bringing game elements into the site.</p>
            <p className="paragraph">We are just two Animal Crossing fans & data storytelling enthusiasts who wanted to take on a fun side project. We are not experts on statistics or video game design. Please do not take our methodology and conclusions too seriously!</p>
            <p className="paragraph">Thanks for reading!</p>
          </section>
        </div>

        <Footer/>
      </div>
    )
  }
}

export default App;
